import { gql } from "@apollo/client";

const ORCH_PROJECT_UPDATE = gql`
    subscription orchProjectUpdate($taskId: ID) {
        orchProjectUpdate(taskId: $taskId) {
            instanceId
            reason
            runtimeStatus
            actionId
            eventType
            actionCompletedOutput
            projectOutput
            error
            taskId
            skipped
            canceled
        }
    }
`;

export { ORCH_PROJECT_UPDATE };
